import { useEffect } from "react";

// Fixed copy of a wide table's header row, shown just under the sticky page
// header while the table scrolls past. Tracks column widths and sideways scroll.
export const StickyTableHeader = ({ targetRef, testid = "sticky-table-header" }) => {
    useEffect(() => {
        const el = targetRef.current;
        if (!el) return undefined;
        const host = document.createElement("div");
        host.setAttribute("data-testid", testid);
        host.className = "fixed z-20 overflow-hidden bg-white border-b border-slate-200 shadow-sm";
        host.style.display = "none";
        document.body.appendChild(host);
        let source = null;

        const build = (table, thead) => {
            const t = document.createElement("table");
            t.className = table.className;
            t.style.tableLayout = "fixed";
            t.style.minWidth = "0";
            const copy = thead.cloneNode(true);
            copy.querySelectorAll("[data-testid]").forEach((n) => n.removeAttribute("data-testid"));
            t.appendChild(copy);
            host.replaceChildren(t);
            source = thead;
        };

        const layout = () => {
            const table = el.querySelector("table");
            const thead = table && table.querySelector("thead");
            const top = document.querySelector("[data-page-header]")?.getBoundingClientRect().bottom ?? 0;
            const r = el.getBoundingClientRect();
            const h = thead ? thead.getBoundingClientRect() : null;
            if (!h || h.top >= top || r.bottom <= top + h.height) {
                host.style.display = "none";
                return;
            }
            if (source !== thead) build(table, thead);
            const t = host.firstChild;
            t.style.width = `${table.offsetWidth}px`;
            const dst = t.querySelectorAll("th");
            thead.querySelectorAll("th").forEach((th, i) => {
                if (dst[i]) dst[i].style.width = `${th.getBoundingClientRect().width}px`;
            });
            t.style.transform = `translateX(${-el.scrollLeft}px)`;
            Object.assign(host.style, { display: "block", top: `${top}px`, left: `${r.left}px`, width: `${el.clientWidth}px` });
        };

        layout();
        window.addEventListener("scroll", layout, true);
        window.addEventListener("resize", layout);
        const ro = new ResizeObserver(layout);
        ro.observe(el);
        return () => {
            window.removeEventListener("scroll", layout, true);
            window.removeEventListener("resize", layout);
            ro.disconnect();
            host.remove();
        };
    }, [targetRef, testid]);
    return null;
};
